/* Get Admin By ID */
export const GET_ADMIN_BY_ID = "GET_ADMIN_BY_ID"
export const GET_ADMIN_BY_ID_SUCCESS = "GET_ADMIN_BY_ID_SUCCESS"
export const GET_ADMIN_BY_ID_FAIL = "GET_ADMIN_BY_ID_FAIL"